/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import '../../assets/styles/components/activity/CommentForm.scss'
import TextInput from '../common/form/TextInput'

const CommentForm = ({
  onInputChange,
  onSubmit,
  loading,
  // user_name,
  value,
  web,
}) => {
  const { t } = useTranslation()
  return (
    <div id='commentForm' className='w-100'>
      <form>
        <div className='' id={web ? 'commentFormWeb' : 'commentFormBox'}>
          <div className='container input-wrapper w-100'>
            <div className='row'>
              <div className='col-md-9'>
                <TextInput
                  name={'Comment Form'}
                  onChange={onInputChange}
                  value={value}
                  className={'commentTextInput'}
                  placeholder={t('activity.commentForm.placeholder')}
                />
              </div>
              <div
                className={`col-md-3 d-flex justify-content-center align-items-center ${!web &&
                  'mt-3'}`}
              >
                <input
                  type='submit'
                  disabled={loading}
                  value={loading ? t('activity.commentForm.posting') : t('activity.commentForm.post')}
                  className='btn btn-primary commentTextSubmit'
                  onClick={onSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CommentForm
